import React, { useMemo } from 'react';

import {
  Menu as ChakraMenu,
  Flex,
  MenuButton,
  MenuList,
  Text,
  MenuItem,
  MenuButtonProps,
} from '@chakra-ui/react';
import { IconPrefix, IconName } from '@fortawesome/fontawesome-svg-core';

import { Icon } from 'components/icon';

type optionType = {
  onClick: () => void
  id: number | string
  label: string
}

interface MenuProps extends MenuButtonProps {
  withIcon?: boolean
  icon?: {
    name?: IconName
    family?: IconPrefix
  }
  options: optionType[]
  size?: string
  selected?: number
}

export default function Menu({
  withIcon = false,
  icon,
  options = [],
  size = 'xs',
  placeholder = 'Text here',
  selected,
  ...rest
}: MenuProps) {
  const sizes = useMemo(() => ({
    xs: {
      fontSize: '2xSmallSemiBold',
      iconSize: '2xs',
    },
    sm: {
      fontSize: 'xSmallSemiBold',
      iconSize: 'xs',
    },
    m: {
      fontSize: 'smallSemiBold',
      iconSize: 'xs',
    },
    l: {
      fontSize: 'mediumSemiBold',
      iconSize: 'xs',
    },
  }),
  []);

  return (
    <ChakraMenu>
      <MenuButton
        as={Flex}
        px={3}
        py={1}
        shadow="s1"
        color="gray.500"
        bg="white.default"
        _hover={{
          color: 'secondary.default',
          cursor: 'pointer',
        }}
        _active={{ color: 'white', bg: 'secondary.default' }}
        borderRadius="20px"
        align="center"
        justify="center"
        fontSize="22px"
        {...rest}>
        <Flex
          flexDir="row"
          align="center"
          justify="center">
          <Text variant={sizes[size].fontSize}>{placeholder}</Text>
          {!!withIcon && (
            <Icon
              name={icon.name || 'caret-down'}
              family={icon.family || 'fas'}
              size={sizes[size].iconSize}
              ml={1}
            />
          )}
        </Flex>
      </MenuButton>
      <MenuList>
        {options.map(({ label, onClick, id }) => (
          <MenuItem
            key={`${label}-${id}`}
            bg={selected === id && 'primary.default'}
            _hover={{ bg: 'secondary.500', color: 'white' }}
            _focus={{ bg: 'secondary.500', color: 'white' }}
            onClick={onClick}>
            <Text variant={sizes[size].fontSize}>{label}
            </Text>
          </MenuItem>
        ))}
      </MenuList>
    </ChakraMenu>
  );
}
